exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhtml {\n  height: 100%;\n}\nbody {\n  height: 100%;\n}\n#app {\n  height: 100%;\n}\n#no-layout-container {\n  height: 100%;\n}\n\n", ""]);

// exports
